import { OUR_HELP } from './ourHelpTypes';

const initialState = {
   message: [],
   success: false,
   loading: true,
   successMsg:"",
   registered: false,
   error: false
}

const ourHelpReducer = (state = initialState, action) => {
    
   switch (action.type) {
      case OUR_HELP:
         return {
            ...state,
            message: action.payload,
            success: true,
            loading: false,
            registered: true
         }

      default:
         return state
   }
}

export default ourHelpReducer
